import React from 'react';

const IconReload = props => (<svg viewBox="0 0 16 16" width="16px" height="16px" {...props}>
  <path d="M13.6575251,2.34247495 L16,0 L16,7 L9,7 L12.2433164,3.75668365 C11.1457358,2.66020268 9.63522314,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C10.5688323,14 12.8277299,12.3707264 13.663859,9.98584905 L15.5512245,10.6475523 C14.4361518,13.8280563 11.4248721,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C10.1802861,0 12.194188,0.880278166 13.6575251,2.34247495 Z" />
</svg>);

export default IconReload;
